module.exports = __webpack_public_path__ + "assets/img/title-3b91c7c3.png";